var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-error text-center alert alert-danger clickable",on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t(_vm.globalError))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }